import { getOffset, smoothScrollTo } from '../../../js/helper';

class ProductSupportResultTable {
    constructor ($content) {
        this.$content = $content;

        this.$toggleButtons = this.$content.querySelectorAll('[data-product-table="toggle"]');
    }

    init () {
        this.bindEvents();
    }

    bindEvents () {
        const addToggleEvents = ($button) => {
            $button.addEventListener('click', () => {
                this.toggleContent($button);
            });
        };

        for (let i = 0; i < this.$toggleButtons.length; i++) {
            const $toggleButton = this.$toggleButtons[i];
            addToggleEvents($toggleButton);
        }
    }

    toggleContent ($button) {
        const $childWrapper = $button.closest('[data-product-table="child"]');

        if ($childWrapper) {
            const $content = $childWrapper.querySelector('[data-product-table="content"]');

            if ($childWrapper.classList.contains('product-support-result__table-children--active')) {
                // close animation
                const contentHeight = $content.scrollHeight;
                $content.style.height = `${contentHeight}px`;

                const top = $button.getBoundingClientRect().top;
                $childWrapper.classList.remove('product-support-result__table-children--active');
                this.scrollToOpenButton($button, top);

                setTimeout(() => {
                    $content.style.height = '0px';
                }, 50);
            } else {
                // open animation
                $content.style.height = 0;
                $childWrapper.classList.add('product-support-result__table-children--active');

                const contentHeight = $content.scrollHeight;
                $content.style.height = `${contentHeight}px`;

                setTimeout(() => {
                    $content.style.height = 'auto';
                }, 250);
            }
        }
    }

    /**
     *
     * @param {DOM Element} $clickedButton - clicked Button
     * @param {Number} buttonOffsetTop - the clicked button offset top to the screen
     */
    scrollToOpenButton ($clickedButton, buttonOffsetTop) {
        const $firstButton = $clickedButton.closest('[data-product-table="child"]').querySelectorAll('[data-product-table="toggle"]')[0];

        // check if clicked button is not the first button, then animate
        if ($firstButton && $firstButton !== $clickedButton) {
            const firstButtonOffsetTop = getOffset($firstButton);
            const scrollTop = firstButtonOffsetTop.top - buttonOffsetTop;

            smoothScrollTo(0, scrollTop);
        }
    }
}

export { ProductSupportResultTable };
